import { ValueType } from 'realgrid'
export const logInfoFields = [
    {fieldName: 'userId', dataType: ValueType.TEXT},
    {fieldName: 'createDt', dataType: "datetime", datetimeFormat: "yyyy-MM-dd HH:mm:ss" },
    {fieldName: 'userIp', dataType: ValueType.TEXT},
    {fieldName: 'menuPathNm', dataType: ValueType.TEXT},
    {fieldName: 'menuPath', dataType: ValueType.TEXT},
    {fieldName: 'menuParam', dataType: ValueType.TEXT},
  ]
  export const logInfoColumns = [
    {
      name: 'userId',
      fieldName: 'userId',
      type: 'data',
      width: '100',
      styleName: "rg-align-left",
      header: {
        "text" : '계정',
        "exportStyleName" : "rg-header-gray",
      }
    },
    {
      name: 'createDt',
      fieldName: 'createDt',
      type: 'data',
      width: '100',
      styleName: "rg-align-left",
      datetimeFormat: "yyyy-MM-dd HH:mm:ss",
      header: {
        "text" : '수행일시',
        "exportStyleName" : "rg-header-gray",
      }
    },
    {
      name: 'userIp',
      fieldName: 'userIp',
      type: 'data',
      width: '100',
      styleName: "rg-align-left",
      header: {
        "text" : 'IP',
        "exportStyleName" : "rg-header-gray",
      }
    },
    {
      name: 'menuPathNm',
      fieldName: 'menuPathNm',
      type: 'data',
      width: '100',
      styleName: "rg-align-left",
      header: {
        "text" : '수행 내역',
        "exportStyleName" : "rg-header-gray",
      }
    },
    {
      name: 'menuPath',
      fieldName: 'menuPath',
      type: 'data',
      width: '100',
      styleName: "rg-align-left",
      header: {
        "text" : 'API 주소',
        "exportStyleName" : "rg-header-gray",
      }
    },
    {
      name: 'menuParam',
      fieldName: 'menuParam',
      type: 'data',
      width: '100',
      styleName: "rg-align-left",
      header: {
        "text" : '처리한정보',
        "exportStyleName" : "rg-header-gray",
      }
    }
  ]